import ajax from "@/lib/ajax";

/**
 * 年龄统计
 */
export async function GetAgeData() {
	let res = await ajax.get(
		`/api/services/app/Statistics/GetAgeData`
	);
	return res.data.result;
}

/**
 * 性别统计
 */
export async function GetSexData() {
	let res = await ajax.get(
		`/api/services/app/Statistics/GetSexData`
	);
	return res.data.result;
}

/**
 * 社区统计
 */
export async function GetCommunityData() {
	let res = await ajax.get(
		`/api/services/app/Statistics/GetCommunityData`
	);
	return res.data.result;
}
/**
 * 社区团队统计
 */
export async function GetTemData() {
	let res = await ajax.get(
		`/api/services/app/Statistics/GetTemData`
	);
	return res.data.result;
}

/**
 * CKD分期统计
 */
export async function GetCkdData() {
	let res = await ajax.get(
		`/api/services/app/Statistics/GetCkdData`
	);
	return res.data.result;
}

/**
 * 随访统计
 */
export async function GetFollowUpData() {
	let res = await ajax.get(
		`/api/services/app/Statistics/GetFollowUpData`
	);
	return res.data.result;
}



// WEBPACK FOOTER //
// ./src/api/pdStatistics/index.ts